module.exports = __webpack_public_path__ + "img/arrow-right.0f1abfc4.svg";